import React from 'react';
import { DeferredRender as OriginalDeferredRender, RenderMode } from '@zillow/react-deferred-hydration';

type DeferredRenderWrapperProps = React.ComponentProps<typeof OriginalDeferredRender>;

/**
 * Wrapper around @zillow/react-deferred-hydration's DeferredRender component that:
 * 1. Automatically adds minHeight/minWidth styles for visibility-based modes to prevent layout shifts
 * 2. Suppresses hydration warnings caused by expected data-renderstrat transitions
 * 3. Merges any custom wrapperProps passed by the consumer
 */
const DeferredRenderWrapper: React.FC<DeferredRenderWrapperProps> = (props) => {
  const { mode, wrapperProps = {}, ...restProps } = props;

  // Modes that use IntersectionObserver need min dimensions to avoid ambiguous behavior
  const needsMinDimensions =
    mode === RenderMode.RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE || mode === RenderMode.RENDER_CLIENT_SIDE_ON_VISIBLE;

  // Extract style from wrapperProps if it exists
  const userStyle = (wrapperProps as any)?.style || {};

  // Merge wrapper props: default styles + user styles + suppressHydrationWarning
  const mergedWrapperProps = {
    ...wrapperProps,
    style: {
      ...(needsMinDimensions ? { minHeight: '1px', minWidth: '1px' } : {}),
      ...userStyle,
    },
    suppressHydrationWarning: true,
  };

  return <OriginalDeferredRender mode={mode} wrapperProps={mergedWrapperProps} {...restProps} />;
};

export { DeferredRenderWrapper as DeferredRender, RenderMode };
